import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // ログに残す（本番環境でもブラウザ console で追跡可）
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="m-4 p-6 bg-white border-2 border-red-300 rounded-md text-slate-800">
          <h2 className="text-lg font-bold text-red-700 mb-2">画面の表示でエラーが発生しました</h2>
          <p className="text-sm text-slate-600 mb-3">
            データの一部に問題があるか、表示処理に予期しない値が含まれている可能性があります。
            ページを再読込するか、フィルタ条件を変えて再度お試しください。
          </p>
          <pre className="text-xs bg-slate-50 border border-slate-200 rounded p-2 overflow-auto max-h-48">
            {String(this.state.error || "")}
          </pre>
          <div className="mt-3 flex gap-2">
            <button
              onClick={this.handleRetry}
              data-testid="error-boundary-retry"
              className="h-9 px-3 rounded-md bg-emerald-600 text-white text-sm hover:bg-emerald-700"
            >
              再試行
            </button>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-boundary-reload"
              className="h-9 px-3 rounded-md border border-slate-300 text-sm hover:bg-slate-50"
            >
              ページを再読込
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
